import React from "react";
import Nav from '../Header/Nav/Nav'

const Header = () => {
  return <header>
    <Nav/>
  </header>;
};

export default Header;
